import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const VerificationView = () => import('../views/VerificationView.vue')
const ResultView = () => import('../views/ResultView.vue')
const StudentResultView = () => import('../components/StudentResult.vue')
const DetailedResultView = () => import('../views/DetailedResultView.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/verify',
    name: 'verification',
    component: VerificationView
  },
  {
    path: '/result',
    name: 'result',
    component: ResultView
  },
  {
    path: '/student-result',
    name: 'student-result',
    component: StudentResultView,
    props: true
  },
  {
    path: '/detailed-result',
    name: 'detailed-result',
    component: DetailedResultView,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
